import React from 'react'
import { CompanyReceivedPersons } from '../../../interfaces/kuvaweb'

type Props = {
  options: Array<CompanyReceivedPersons>
  value: string
  onChange: (value: string) => void
}

const ReceivedPersonsToggle: React.FC<Props> = ({
  options,
  value,
  onChange,
}) => {
  return (
    <div className="received-persons-toggle">
      {options.map(option => (
        <label
          key={option.idNumber}
          className={value === option.idNumber ? 'active' : ''}
        >
          <input
            type="radio"
            name="toggle"
            value={option.idNumber}
            checked={value === option.idNumber}
            onChange={() => onChange(option.idNumber)}
          />
          <span>{`${option.firstName} ${option.lastName}`}</span>
          <span>{option.idNumber}</span>
        </label>
      ))}
    </div>
  )
}

export default ReceivedPersonsToggle
